import { render } from "./closedLoopProblem.vue?vue&type=template&id=1c2f8726&scoped=true"
import script from "./closedLoopProblem.vue?vue&type=script&lang=js"
export * from "./closedLoopProblem.vue?vue&type=script&lang=js"

import "./closedLoopProblem.vue?vue&type=style&index=0&id=1c2f8726&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2f8726"]])

export default __exports__